import { useEffect, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { checkCanPublish, restartCanPublishCheck } from './store/thunks';
import { selectHasPrivileges } from '../../store/rootSelectors';
import { useSelector } from 'react-redux';

export default function useSnapshotChecker() {
  const [hasChecked, setHasChecked] = useState(false);
  const hasPublishPrivelege = useSelector(selectHasPrivileges('cms.manageContent'));
  const dispatch = useDispatch();

  // Define a callback to restart the publish check process
  const restartPublishCheck = useCallback(() => {
    dispatch(restartCanPublishCheck());
  }, [dispatch]);

  useEffect(() => {
    if (!hasChecked && hasPublishPrivelege) {
      // Initial check when the component mounts
      dispatch(checkCanPublish({ hasChecked: false }));
      setHasChecked(true);
    }
  }, [dispatch, hasPublishPrivelege, hasChecked, setHasChecked]);

  // Return the restart function so other components can trigger a check
  return {
    restartPublishCheck,
  };
}
